import React from 'react';
import { Button, Modal } from 'react-bootstrap'

/**
 * @author Teyim Pila <teyim.pila@gmail.com>
 * @date 09/10/2018 : 11:52 AM
 */

const ConfirmationModal = (props) => {
    const {payload, onSave, onHide, show, headerText, bodyText, buttonText} = props;
    return (
        <Modal show={show} onHide={onHide} className="tms-modal-dialog">
            <Modal.Header closeButton>
                <Modal.Title>{headerText}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className={"confirmation-modal-text"}>
                    <div>
                        <span>{bodyText}</span>
                    </div>
                </div>

            </Modal.Body>
            <Modal.Footer>
                <Button onClick={onHide} className="btn btn-default">Cancel</Button>
                <Button bsStyle="success" onClick={() => onSave(payload)}>{buttonText}</Button>
            </Modal.Footer>
        </Modal>);
};

export default ConfirmationModal;
